import Contact from "../components/contact/contact";


const ContactPage = () => {
    return <div>
        <Contact />
    </div>
};

export default ContactPage;